/**
 * @func 检测email是否合法
 * @param {*} email
 * @returns
 */
const validEmail = (email) => {
    // 使用正则表达式检测电子邮件地址的格式
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
}

/**
 * @func 检测值是否为空
 * @param {*} value
 * @returns
 */
const validValue = (value) => {
    if (value === null || value === undefined || value === "" || value === "null" || value === "undefined" || value === "None") {
        return false
    }
    return true
}

export { validEmail, validValue }
